/**
 * Batch #14.138 — Pastille rouge pour les compteurs d'action admin.
 *
 * Affiche un compteur si > 0, sinon rien. Tronque au-delà de 99.
 *
 * Variants :
 *   - `dot`     : petit point rouge (header sidebar) sans nombre
 *   - `count`   : pastille rouge ronde avec chiffre
 *
 * Usage :
 *   <Badge count={3} />
 *   <Badge count={150} />     // affiche "99+"
 *   <Badge count={0} />        // rien
 */

export function Badge({ count = 0, variant = "count", className = "", testid }) {
  const n = Number(count) || 0;
  if (n <= 0) return null;

  if (variant === "dot") {
    return (
      <span
        className={`inline-block w-2 h-2 rounded-full bg-rose-500 ring-2 ring-white ${className}`}
        data-testid={testid}
        aria-label={`${n} action(s) à voir`}
      />
    );
  }

  const display = n > 99 ? "99+" : String(n);
  return (
    <span
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold leading-none rounded-full bg-rose-500 text-white ring-2 ring-white ${className}`}
      data-testid={testid}
      aria-label={`${n} action(s) à voir`}
    >
      {display}
    </span>
  );
}

export default Badge;
